const data = [
  {
    id: 8,
    img: "img/chatApp.png",
    name: "[WorkingOn]Chat App",
    explain:
      "This website is using for chatting with other users and posting feeds",
    stack: ["React", "Node", "Express", "MongoDB"],
    website: "",
    figma: "",
    git: "https://github.com/Jeungbin/MERN-social-final",
    href: "/InfoTwo",
  },
  {
    id: 7,
    img: "img/Desktop - 1.svg",
    name: "[WorkingOn]Management App,CRUD",
    explain:
      "This website is using for management the user. You can organize, create, update and delete user's info.",
    stack: ["JavaScript", "Node", "Express", "MongoDB"],
    website: "",
    figma: "",
    git: "https://github.com/Jeungbin/Yoshiko-Management-App",
    href: "/info",
  },
  {
    id: 1,
    img: "img/work3.svg",
    name: "Japaness Academy's Study Platform",
    explain:
      "Online book for the users who are trying to learn Japaness. Don't need a book, you can only need your phone to study.",
    stack: ["Design"],
    website: "",
    figma:
      "https://www.figma.com/file/K98krAZrGymeQQZJvpwGtH/WIT-assignment?node-id=0%3A1",
    git: "",
  },
  {
    id: 2,
    img: "img/work1.svg",
    name: "Japaness Academy Website-var2",
    explain: "Design for the Japaness Online Academy varsion 2",
    stack: ["Design"],
    website: "",
    figma:
      "https://www.figma.com/file/TSAiRBP3dLhRa3Cemxd2C0/Untitled?node-id=0%3A1",
    git: "",
  },
  {
    id: 3,
    img: "img/work2.svg",
    name: "Japaness Academy Website",
    explain: "Design for the Japaness Online Academy",
    stack: ["Design"],
    website: "",
    figma: "https://www.figma.com/file/vpeCqaUhjZ4kpnhiEUMocS/Untitled",
    git: "",
  },
  {
    id: 4,
    img: "img/firebase.png",
    name: "Firebase Pjoject",
    stack: ["JavaScript", "Firebase"],
    website: "https://js-and-firebase-assignment.jeungbinhan.repl.co/",
    explain:
      "User can make own id, and check remaining days by his birthday. I made this to experiece and practice saving user's data to use Firebase.",
    figma: "",
    git: "https://github.com/Jeungbin/Firebase-and-JavaScipt_birthdayProject",
  },
  {
    id: 5,
    img: "img/portfolio.png",
    name: "My Portfolio",
    stack: ["React", "JavaScript"],
    website: "https://main--jbinportfoli.netlify.app/",
    explain: "My portfolio that I used 'React'.",
    figma: "",
    git: "https://github.com/Jeungbin/Portfolio",
  },
  {
    id: 6,
    img: "img/express.png",
    name: "[Practice] Management App,CRUD",
    stack: ["JavaScript", "Express", "MongoDB", "EJS"],
    explain:
      "Management Application that user can review , create, update and delete the info.",
    website: "",
    figma: "",
    git: "https://github.com/Jeungbin/CRUD_Practice-with-express-node-and-MD",
  },
];

export default data;
